// extracted by mini-css-extract-plugin
export default {"statsContainer":"styles_statsContainer__2OAq3","resultsStats":"styles_resultsStats__dHkiP"};